// extracted by css-extract-rspack-plugin
export default {"highlight":"_AYbd","editor":"dx0yt"};